/* VFP redesign behaviour. Each section initialises on load and again when the
   theme editor re-renders it (shopify:section:load). */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Hero: the meanings of No niin, colour photos, and swatches that deep-link to the variant */
  function hero(root) {
    var roll = root.querySelector('[data-roll]'), cta = root.querySelector('[data-cta]');
    var photos = $$('.vfp-frame img', root), sw = $$('.vfp-swatch', root), name = root.querySelector('.vfp-swatch-name');
    var meanings = [];
    try { meanings = JSON.parse(root.getAttribute('data-meanings') || '[]'); } catch (e) {}
    var mi = 0, tick = 0, pi = Math.max(0, photos.findIndex(function (p) { return p.classList.contains('is-on'); })), auto = true, timer = null;
    function setPhoto(i, chosen) {
      pi = i;
      photos.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      sw.forEach(function (s, k) { s.setAttribute('aria-pressed', String(k === i)); });
      if (name && sw[i]) name.textContent = sw[i].getAttribute('data-name');
      if (chosen && cta && sw[i]) cta.href = sw[i].getAttribute('data-url');
    }
    sw.forEach(function (s, k) { s.addEventListener('click', function () { auto = false; setPhoto(k, true); }); });
    function next() {
      if (meanings.length > 1 && roll) {
        mi = (mi + 1) % meanings.length;
        if (roll.animate) {
          roll.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-60%)', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(.5,0,.75,0)' }).onfinish = function () {
            roll.textContent = meanings[mi];
            roll.animate([{ transform: 'translateY(60%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.9,.25,1.25)' });
          };
        } else { roll.textContent = meanings[mi]; }
      }
      /* the shirt changes colour on every other line, so there is time to look at it */
      tick++;
      if (auto && photos.length > 1 && tick % 2 === 0) setPhoto((pi + 1) % photos.length, false);
    }
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        clearInterval(timer);
        if (entries[0].isIntersecting) timer = setInterval(next, 2600);
      }).observe(root);
    }
  }

  /* Word marquee: drifts on its own, speeds up and turns with the reader's scroll */
  function band(root) {
    var track = root.querySelector('.vfp-band__track');
    if (!track || reduce || track.dataset.ready) return;
    track.dataset.ready = '1';
    track.innerHTML += track.innerHTML;
    $$('.vfp-band__item, .vfp-band__flag', track).slice(track.children.length / 2).forEach(function (n) { n.setAttribute('aria-hidden', 'true'); });
    var x = 0, dir = -1, vel = 0, lastY = window.scrollY, lastT = performance.now(), visible = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(root);
    function frame(t) {
      var dt = Math.min(64, t - lastT); lastT = t;
      var y = window.scrollY, dy = y - lastY; lastY = y;
      vel = vel * .88 + dy * .12;
      if (Math.abs(dy) > .5) dir = dy > 0 ? -1 : 1;
      if (visible) {
        x += dir * (0.5 + Math.min(Math.abs(vel) * .9, 18)) * dt / 16.7;
        var half = track.scrollWidth / 2;
        if (x <= -half) x += half; if (x > 0) x -= half;
        track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* Year strip: open on the current month, label it, and step with the arrows */
  function year(root) {
    var strip = root.querySelector('.vfp-strip'), cards = $$('.vfp-month', root);
    if (!strip || !cards.length) return;
    var now = new Date().getMonth();
    var current = cards.findIndex(function (c) { return +c.getAttribute('data-month') === now; });
    if (current > -1) {
      var top = cards[current].querySelector('.vfp-month__top');
      if (top && !top.querySelector('.vfp-month__now')) {
        var chip = document.createElement('span'); chip.className = 'vfp-month__now'; chip.textContent = root.getAttribute('data-now-label') || 'This month';
        top.appendChild(chip);
      }
    }
    function pad() { return parseFloat(getComputedStyle(strip).scrollPaddingLeft) || 0; }
    function go(i, smooth) { var c = cards[Math.max(0, Math.min(cards.length - 1, i))]; strip.scrollTo({ left: c.offsetLeft - pad(), behavior: smooth && !reduce ? 'smooth' : 'auto' }); }
    function idx() { var best = 0, d = 1e9; cards.forEach(function (c, i) { var v = Math.abs(c.offsetLeft - pad() - strip.scrollLeft); if (v < d) { d = v; best = i; } }); return best; }
    if (current > -1) go(current, false);
    var prev = root.querySelector('[data-prev]'), nextB = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(idx() - 1, true); });
    if (nextB) nextB.addEventListener('click', function () { go(idx() + 1, true); });
  }

  /* Word cards flip to show what the word literally means */
  function words(root) {
    $$('.vfp-word', root).forEach(function (card) {
      var front = card.querySelector('.vfp-face--front'), back = card.querySelector('.vfp-face--back');
      var open = card.querySelector('.vfp-word__open'), close = card.querySelector('.vfp-word__back');
      function set(f) {
        card.classList.toggle('is-flipped', f); open.setAttribute('aria-expanded', String(f));
        if (f) { front.setAttribute('inert', ''); back.removeAttribute('inert'); setTimeout(function () { close.focus({ preventScroll: true }); }, 50); }
        else { back.setAttribute('inert', ''); front.removeAttribute('inert'); setTimeout(function () { open.focus({ preventScroll: true }); }, 50); }
      }
      open.addEventListener('click', function () { set(true); });
      close.addEventListener('click', function () { set(false); });
    });
  }

  /* Quiz teaser: answer question one here, then carry on at the quiz */
  function quiz(root) {
    var opts = $$('.vfp-q-opt', root), wrap = root.querySelector('.vfp-q-options'), res = root.querySelector('.vfp-q-result'), react = root.querySelector('.vfp-q-react'), go = root.querySelector('[data-quiz-go]');
    var base = go ? go.getAttribute('href') : '';
    opts.forEach(function (b, n) {
      b.addEventListener('click', function () {
        opts.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        wrap.classList.add('answered'); react.textContent = b.getAttribute('data-r');
        if (go) go.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'a1=' + (n + 1);
        res.hidden = false; react.focus({ preventScroll: true });
      });
    });
  }

  /* Guide signup: MailerLite posts into a hidden frame, so the reader stays put */
  function guide(root) {
    var form = root.querySelector('form'), note = root.querySelector('.vfp-guide__fine');
    if (!form) return;
    form.addEventListener('submit', function () {
      setTimeout(function () { form.style.display = 'none'; if (note) note.innerHTML = root.getAttribute('data-success') || '<strong>Nearly there.</strong> Check your inbox and click confirm, then the guide is on its way.'; }, 400);
    });
  }

  var INIT = { hero: hero, band: band, year: year, words: words, quiz: quiz, guide: guide };
  function initAll(scope) {
    $$('[data-vfp-section]', scope).forEach(function (el) {
      if (el.dataset.vfpInit) return;
      el.dataset.vfpInit = '1';
      var fn = INIT[el.getAttribute('data-vfp-section')];
      if (fn) fn(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
